import React from "react";
import { Container } from "components/generic/layout";
import { Overlay } from "components/common/candidate";
import { NarrowBody } from "components/generic/layout";
import { Title, Row, Label, ErrorBox } from "components/generic/form/service";
import {
  Input,
  Formik,
  Select,
  File,
  PhotoUpload
} from "components/generic/form/formik";
import { Button } from "components/generic/kit";
import { Timezone } from "core/utils";

export default ({
  validationSchema,
  initialValues,
  errors,
  editApi,
  updateAvatarApi,
  onSubmitAvatar,
  onSubmit
}) => (
  <Overlay>
    <Container>
      <NarrowBody>
        <Formik initialValues={initialValues} onSubmit={onSubmitAvatar}>
          {props => (
            <form onSubmit={props.handleSubmit}>
              <Row>
                <PhotoUpload
                  type="file"
                  name="photo"
                  photo={initialValues.avatar}
                />
              </Row>
              {props.dirty && (
                <div className="tc mb2">
                  <Button
                    size="small"
                    type="submit"
                    disabled={updateAvatarApi.isFetching}
                  >
                    Update avatar
                  </Button>
                </div>
              )}
            </form>
          )}
        </Formik>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          errors={errors.field}
        >
          {props => (
            <div>
              <Title>Personal Information</Title>
              {!!errors.nonField.length && (
                <ErrorBox errors={errors.nonField} />
              )}
              <form onSubmit={props.handleSubmit}>
                <Row>
                  <Label title="First name">
                    <Input
                      name="first_name"
                      type="text"
                      placeholder="Enter your first name"
                    />
                  </Label>
                </Row>
                <Row>
                  <Label title="Last name">
                    <Input
                      name="last_name"
                      type="text"
                      placeholder="Enter your last name"
                    />
                  </Label>
                </Row>
                <Row>
                  <Label title="Phone">
                    <Input
                      name="phone"
                      type="text"
                      placeholder="Enter your phone number"
                    />
                  </Label>
                </Row>
                <Row>
                  <Label title="Timezone">
                    <Select name="timezone" type="select">
                      {Timezone.map((i, index) => (
                        <option key={index} value={i}>
                          {i}
                        </option>
                      ))}
                    </Select>
                  </Label>
                </Row>
                <Row>
                  <Label title="Update your resume">
                    <File name="resume" />
                  </Label>
                </Row>
                <div className="mt3 flex items-center">
                  <Button
                    color="white"
                    type="submit"
                    disabled={editApi.isFetching}
                  >
                    Submit changes
                  </Button>
                </div>
              </form>
            </div>
          )}
        </Formik>
      </NarrowBody>
    </Container>
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/EditProfile/View.js